<template>
  <div class="m_menu">
    <van-nav-bar title="" />
    <van-nav-bar
      :title="topTitle"
      left-arrow
      @click-left="onClickLeft"
      class="topTitle"
    />
    <!-- <div class="bigTitle">河南大学教学管理规范化服务平台</div> -->
    <!-- <div class="oopName">学生事项</div> -->
    <van-collapse v-model="activeName" accordion class="itemList">
      <van-collapse-item
        :title="item.className"
        :name="item.classID"
        v-for="item in menuList"
        :key="item.classID"
        :class="activeName == item.classID ? 'actTest list1' : 'list1'"
      >
        <div
          class="subMenu"
          v-for="item in subMenuList"
          :key="item.subClassID"
          @click="entryOoplist(item.subClassID)"
        >
          <span>{{ item.subClassName }}</span>
          <img src="@/assets/right.svg"/>
        </div></van-collapse-item
      >
    </van-collapse>
    <div class="m_bottom">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
import { findClass1byObj, findClass2byClass1 } from "../../utils/api.js";
export default {
  name: "m_menu",
  watch: {
    activeName: function (val, oldval) {
      console.log(val, oldval);
      this.showSubClass(val);
    },
  },
  mounted: function () {
    console.log("从vuex中获取到的对象", this.$store.state.role);
    this.topTitle = this.$store.state.role;

    findClass1byObj(this.$store.state.roleCode).then((result) => {
      console.log(result);
      this.menuList = result;
    });
  },
  data() {
    return {
      activeName: "0",
      aha: [123, 456, 789],
      topTitle: "",
      menuList: [
        // {
        //   classID: "1",
        //   className: "学籍管理",
        //   classObjectID: "10",
        //   department: "11",
        // },
      ],
      subMenuList: [],
    };
  },
  methods: {
    //进入列表页
    entryOoplist: function (subClassId) {
      // console.log(subClassId);

      this.$store.commit("subClassId", subClassId);
      this.$router.replace("./m_ooplist");
      // this.$router.replace({
      //   path: "./oopList",
      //   name: "OopList",
      //   params: {
      //     subClassId: subClassId,
      //   },
      // });
    },
    //van-nav-bar左侧点击返回
    onClickLeft: function () {
      console.log("menu返回点击了，返回上一页./");
      this.$router.replace("./m_home");
    },
    //展示二级标题
    showSubClass(class1Id) {
      console.log(class1Id);
      if (class1Id) {
        findClass2byClass1(class1Id).then((result) => {
          console.log(result);
          this.subMenuList = result;
        });
      }
    },
  },
};
</script>

<style >
.m_menu {
  text-align: left;
  width: 100vw;
  height: 100vh;
  background: #fff;
}
.van-cell__title,
.van-cell__value {
  font-size: large;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
.van-nav-bar__arrow {
  font-size: 20px;
}
.van-nav-bar__content {
  padding: 5px 2px;
}
.van-nav-bar__title {
  font-size: 20px;
}
.van-cell {
  padding: 10px 20px;
  background: #f3f8fd;
}
.van-collapse-item__title--expanded {
  background: #f3f8fd;
}
.van-collapse-item__icon {
  display: none;
}
van-cell__right-icon {
  display: none;
}
.bigTitle {
  font-size: 20px;
  width: 100vw;
  height: 10rem;
  line-height: 10rem;
  text-align: center;
  font-size: 6vw;
  border-bottom: 10px solid #09f;
}
.inBTM {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 55px;
  line-height: 55px;
  background-color: whitesmoke;
  text-align: center;
  font-size: 14px;
  background-color: #09c;
  color: white;
}
.oopName {
  width: 100vw;
  text-align: center;
  height: 35px;
  line-height: 35px;
  font-size: 18px;
}
.van-collapse-item__content {
  padding: 0px 16px;
}
.subMenu {
  /* height: 25px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left:10px;
  margin-right: 10px;
  padding: 10px 3px 10px 10px;
  font-size: 18px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  border-bottom: 1px solid  #D8D8D8;
}
.subMenu:last-child {
  border-bottom: none;
}
.topTitle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>